import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Modules from './components/Modules';
import HowItWorks from './components/HowItWorks';
import DemoVideo from './components/DemoVideo';
import Features from './components/Features';
import UseCases from './components/UseCases';
import Pricing from './components/Pricing';
import ApplicationSection from './components/ApplicationSection';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LeadOfferModal from './components/LeadOfferModal';
import TermsOfUsePage from './pages/TermsOfUsePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import KvkkDisclosurePage from './pages/KvkkDisclosurePage';

function normalizePath(pathname) {
  const normalized = (pathname || '/').replace(/\/+$/, '');
  return normalized === '' ? '/' : normalized;
}

function App() {
  const currentPath = typeof window !== 'undefined' ? normalizePath(window.location.pathname) : '/';
  const isApplicationPage = currentPath === '/basvuru';
  const legalPageMap = {
    '/kullanim-kosullari': TermsOfUsePage,
    '/gizlilik-politikasi': PrivacyPolicyPage,
    '/cerez-politikasi': CookiePolicyPage,
    '/kvkk-aydinlatma-metni': KvkkDisclosurePage,
  };
  const ActiveLegalPage = legalPageMap[currentPath];

  if (isApplicationPage) {
    return (
      <div className="min-h-screen bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100">
        <Navbar />
        <main className="pt-20">
          <ApplicationSection />
        </main>
        <Footer />
      </div>
    );
  }

  if (ActiveLegalPage) {
    return (
      <div className="min-h-screen bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100">
        <Navbar />
        <main className="pt-20">
          <ActiveLegalPage />
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100">
      <Navbar />
      <main>
        <Hero />
        <Modules />
        <HowItWorks />
        <DemoVideo />
        <Features />
        <UseCases />
        <Pricing />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <LeadOfferModal />
    </div>
  );
}

export default App;
